<div class="embla">
	<div class="embla__viewport" #viewport>
	  <div class="embla__container">
		@for (slide of slides; track slide;let i = $index) {
			<div class="embla__slide" (click)="carousalRedirection(i)">
				<img [src]="slide" alt="Slide" />
			</div>
		}
	  </div>
	</div>
	
		<div class="embla__controls">
			<div class="embla__buttons">
				<div class="embla__pagination">
					@for (page of slides; track page;let i = $index) {
						<button [class.is-selected]="i === selectedIndex" (click)="scrollToSlide(i)"></button>
					}
				  
				</div>
				@if(!universalService.isMobileDevice){
					<div class="embla__arrow__buttons">
						<div class="circle-arrow arrow-left" (click)="scrollPrev()">
						<div class="arrow"></div>
						</div>
			
						<div class="circle-arrow arrow-right" (click)="scrollNext()">
						<div class="arrow"></div>
						</div>
					</div>
				}
			</div>
		  </div>
	

</div>